import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind/index.css';
import reportWebVitals from './reportWebVitals';
import { Homepage } from './pages/Homepage';
import { AuthContainer } from './containers/AuthContainer';

ReactDOM.render(
  <AuthContainer>
    <Homepage />
  </AuthContainer>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
